import { SxProps } from '@mui/material/styles';

export const containerStyles: SxProps = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
};

export const contentBodyStyles: SxProps = {
  textAlign: 'center',
  whiteSpace: 'pre-line',
  mt: 1,
};

export const errorIconStyles: SxProps = {
  height: 80,
  width: 80,
  mb: 1,
  color: 'error.main',
};

export const successIconStyles: SxProps = {
  height: 80,
  width: 80,
  mb: 1,
  color: 'info.main',
};

export const acknowledgeContentBodyStyles: SxProps = {
  textAlign: 'center',
  whiteSpace: 'pre-line',
  mt: 1,
  mb: 2,
};

export const confirmingLoaderStyles: SxProps = {
  mb: 1,
  fontWeight: 600,
};
